class RacedayEditFormController {
  constructor() {
    this.name = 'racedayEditForm';
  }
}

export default RacedayEditFormController;
